
let initialState = {
    api: ''
};

const HSIReducer = (state = initialState, action) => {
    return state;
}

export default HSIReducer;